import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toCApi } from "../../../../utils";
import TopicsMenuNode from "../../LearningTracking/MainMenu/TopicsMenuNode";
import topicIcon from '../../../../assests/course/topicIcon.png'
import deleteIcon from '../../../../assests/assessments/new/delete-icon.png'
import editIcon from '../../../../assests/toc/edit-icon.png'
import classes from './NodeTreeEditTopic.module.css'
import { onKeyDown } from '../../../../service';
import Permissions from "../../../Permissions";
import { UserActivityEnum } from "../../../../models/UserActivityEnum";
import DynamicMessage from "../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../../lms-shared/models/DynamicMessageTypeEnum";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";

const NodeTreeEditTopic = ({updateTopicOrder, topicId, isProfession, topic, studyGroupId, courseName, disableEditLesson = false, disableDeleteLesson = false, addNewLesson, refreshTopicList ,isDraggable}) => {

    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction) === 'rtl';
    const [showSubTopic, setShowSubTopic] = useState()
    const [edit, setEdit] = useState(false)
    const [topicNewName, setTopicNewName] = useState(null)
    const [messagePopup, setMessagePopup] = useState()
    const dispatch = useDispatch()

    const onDeleteTopic = (e) => {
        e.stopPropagation()
        setMessagePopup(<DynamicMessage
            type={DynamicMessageTypeEnum.Warn}
            content={texts.MessageContentDeleteProfession}
            cancelFunc={() => setMessagePopup(false)}
            confirmFunc={deleteTopic} />)
    }

    const deleteTopic = () => {
        setMessagePopup(false)
        toCApi.toCDeleteIdPost(topic.id, (error, resdata, response) => {
            if (error) {
                setMessagePopup(<DynamicMessage
                    type={DynamicMessageTypeEnum.Error}
                    title={texts.MessageTitleErrorOccurred}
                    content={texts.errMsgDeleteTocWithChildren}
                    confirmFunc={() => setMessagePopup(false)} />)
            }
            else {
                refreshTopicList()
            }
        })
    }

    const editTopic = () => {
        setEdit(false)
        if (topicNewName) {
            const data = {
                id: topic.id,
                name: topicNewName,
                description: "",
                active: true,
                visible: true
            }
            toCApi.toCUpdatePost({ toCUpdateInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "toCUpdatePost " + error.message, level: 1, component: "NodeTreeEditTopic", line: 63 }))
                }
                else {
                    refreshTopicList()
                }
            })
        }
    }

    return (
        <>
            {messagePopup}
            <div className={`${classes.Topic} ${topic.children.length > 0 && classes.ChildrenContainer} ${showSubTopic && classes.TopicOpen}`} >
                <div className={classes.NameContainer} onClick={() => setShowSubTopic((prevShowSubTopic) => !prevShowSubTopic)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowSubTopic((prevShowSubTopic) => !prevShowSubTopic))}>
                    <p className={classes.Arrow}>{showSubTopic ? '⮟' : direction ? '⮜' : '⮞'}</p>
                    <img src={topicIcon} className={classes.TopicIcon} alt="TopicIcon" />
                    {edit ?
                        <input type='text'
                            defaultValue={topic.name}
                            name="editTopic"
                            className={classes.Input}
                            onChange={(e) => setTopicNewName(e.target.value)}
                            onBlur={editTopic}
                        />
                        :
                        <p className={classes.Name}>{topic.name}</p>}
                    {isProfession && <Permissions activityType={UserActivityEnum.EditCourse} > <img src={editIcon} alt="editIcon" className={`${classes.Icon} ${classes.Edit}`} onClick={() => setEdit(true)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => () => setEdit(true))} /></Permissions>}
                    {isProfession && <Permissions activityType={UserActivityEnum.EditCourse} ><img src={deleteIcon} alt="deleteIcon" className={`${classes.Icon} ${classes.Delete}`} onClick={onDeleteTopic} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, onDeleteTopic)} /></Permissions>}
                </div>
                {showSubTopic && topic.children && <TopicsMenuNode isDraggable={isDraggable} updateTopicOrder={updateTopicOrder} topicId ={topicId} isProfession={isProfession} disableEditLesson={disableEditLesson} disableDeleteLesson={disableDeleteLesson} addNewLesson={addNewLesson} myClass={'TreeEditCourse'} topicsData={topic.children} courseName={courseName} tocName={topic.name} toCParentId={topic.id} studyGroupId={studyGroupId} refreshTopicList={refreshTopicList}></TopicsMenuNode>}
            </div>

        </>
    )
}

export default NodeTreeEditTopic;